<template>
<div class="logs">
    <v-container fluid class="pt-0">
      <v-card class="no-shadow pa-2">

      <v-toolbar class="primary card-r pl-3 text-white">
        <div class="text-xs-left f-20">Payment Logs</div>
      </v-toolbar>
        <div class="table2 pt-3">
            <!--<p class="textColor font-weight-black display-1 text-md-center">Payment Logs</p>-->
              <TableWithoutView v-if="loading===false" :headers="headers" :items="logsData" :pagination="pagination"></TableWithoutView>
        </div>
        <!-- <v-dialog v-model="dialog" width="500">
            <v-card>
                 <v-toolbar color="white" class="py-3" >

                        <v-toolbar-title class="display-2 ma-auto ">Invoice</v-toolbar-title>

                    </v-toolbar>
                <div class="resultContainer py-5 px-5">

                    <div class="">
                        <v-layout row wrap class="">

                            <v-flex xs6>
                                <h4 class="headline text-capitalize font-weight-black" v-text="logData.club_name"></h4>
                                <span x2  class=""> Date : {{logData.date}}</span>
                            </v-flex>
                            <v-flex xs6 class="text-xs-right" >
                                <p class="mb-0">Total</p>
                                <p class="display-1 font-weight-black">{{logData.price}}</p>
                            </v-flex>
                        </v-layout>
                        <v-divider class="pa-3"></v-divider>
                        <v-layout row wrap class="invoiceTable px-2">
                            <v-flex xs12>
                                <table class="elevation-3">
                                    <tr>
                                        <th>Packages</th>
                                        <th>Amount</th>
                                    </tr>
                                    <tr v-for="i in logData.memberships" :key="i.id">
                                        <td v-text="i.name"></td>
                                        <td v-text="i.cost"></td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>

                    </div>
                </div>
            </v-card>
        </v-dialog> -->
      </v-card>
    </v-container>

</div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
//import LogView from './LogView.vue'
import TableWithoutView from "@/components/TableWithoutView.vue";
import {
    log
} from 'util';
export default {
    name: "logs",
    data: () => ({
        dialog: false,
        logData:null,


        selected: [],
        headers: [
            {
                text: "Date",
                value: 'date'
            },
            {
                text: "Payer",
                value: 'payer_name'
            },
            {
                text: "Payee",
                value: 'payee_name'
            },
            {
                text: "Description",
                value: 'description'
            },
             {
                text: "Payment Status",
                value: 'status'
            },
            // {
            //     text: "Type",
            //     value: 'type'
            // },
            {
                text: "Class Name",
                value: 'class_payment.booking.module_name'
            },
            {
                text: "Class Date",
                value: 'class_payment.booking.date'
            },
             {
                text: "Class Time",
                value: 'class_payment.booking.time'
            },
            // {text:"Status",value:'status'},

        ],
        logs: [],

    }),
    created() {
          Store.dispatch('getLogs')
    },
    methods: {

        viewLogs(id) {
            this.$store.dispatch("getLog", id)
                .then(
                    response => {
                        this.EarningData = response.data
                        this.dialog = true
                        // this.$router.push("/logview/"+id)


                    },
                    error => {
                        this.$notify({
                            group: "error",
                            type: "error",

                            text: "error"
                        });
                    }
                );
        //
        }
    },
    computed: {
       ...mapState({
            logsData: "logsData",
            pagination: "pagination",
            loading: "loading",
            mode: "mode",
       })
    },
    components: {
        //LogView,
        TableWithoutView
    }

}
</script>



// WEBPACK FOOTER //
// src/pages/pages/Logs.vue